// Copyright 2022 Google LLC. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gnostic/openapi/v3/annotations.proto (package gnostic.openapi.v3, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { Document, Operation, Schema } from "./openapiv3_pb";
import { file_gnostic_openapi_v3_openapiv3 } from "./openapiv3_pb";
import type { FieldOptions, FileOptions, MessageOptions, MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file gnostic/openapi/v3/annotations.proto.
 */
export const file_gnostic_openapi_v3_annotations: GenFile = /*@__PURE__*/
  fileDesc("CiRnbm9zdGljL29wZW5hcGkvdjMvYW5ub3RhdGlvbnMucHJvdG8SEmdub3N0aWMub3BlbmFwaS52MzpXCghkb2N1bWVudBIcLmdvb2dsZS5wcm90b2J1Zi5GaWxlT3B0aW9ucxj3CCABKAsyHC5nbm9zdGljLm9wZW5hcGkudjMuRG9jdW1lbnRSCGRvY3VtZW50OlwKCW9wZXJhdGlvbhIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGPcIIAEoCzIdLmdub3N0aWMub3BlbmFwaS52My5PcGVyYXRpb25SCW9wZXJhdGlvbjpUCgZzY2hlbWESHy5nb29nbGUucHJvdG9idWYuTWVzc2FnZU9wdGlvbnMY9wggASgLMhouZ25vc3RpYy5vcGVuYXBpLnYzLlNjaGVtYVIGc2NoZW1hOlYKCHByb3BlcnR5Eh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxj3CCABKAsyGi5nbm9zdGljLm9wZW5hcGkudjMuU2NoZW1hUghwcm9wZXJ0eUJaCg5vcmcub3BlbmFwaV92M0IQQW5ub3RhdGlvbnNQcm90b1ABWi5naXRodWIuY29tL2dvb2dsZS9nbm9zdGljL29wZW5hcGl2MztvcGVuYXBpX3YzogIDT0FTYgZwcm90bzM", [file_gnostic_openapi_v3_openapiv3, file_google_protobuf_descriptor]);

/**
 * @generated from extension: gnostic.openapi.v3.Document document = 1143;
 */
export const document: GenExtension<FileOptions, Document> = /*@__PURE__*/
  extDesc(file_gnostic_openapi_v3_annotations, 0);

/**
 * @generated from extension: gnostic.openapi.v3.Operation operation = 1143;
 */
export const operation: GenExtension<MethodOptions, Operation> = /*@__PURE__*/
  extDesc(file_gnostic_openapi_v3_annotations, 1);

/**
 * @generated from extension: gnostic.openapi.v3.Schema schema = 1143;
 */
export const schema: GenExtension<MessageOptions, Schema> = /*@__PURE__*/
  extDesc(file_gnostic_openapi_v3_annotations, 2);

/**
 * @generated from extension: gnostic.openapi.v3.Schema property = 1143;
 */
export const property: GenExtension<FieldOptions, Schema> = /*@__PURE__*/
  extDesc(file_gnostic_openapi_v3_annotations, 3);

